import { Validators } from "@angular/forms";

export const EmailPatternValidator = Validators.pattern("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
export const StoreNamePatternValidator = Validators.pattern("^[ a-zA-Z0-9]{0,30}$");
export const SubDomainPatternValidator = Validators.pattern("^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$");
export const DomainPatternValidator = Validators.pattern("^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(xn--[a-zA-Z0-9-]{1,59}|[a-zA-Z]{2,63})$");
export const AlphaNumericOnly = Validators.pattern("^[a-zA-Z0-9]+$");
export const AlphaNumericAndDashOnly = Validators.pattern("^[a-zA-Z0-9-]+$");
export const AlphaNumericAndDashAndSpaceOnly = Validators.pattern("^[a-zA-Z0-9- ]+$");
